import {
  GetResultValidationsDocument,
  GetResultValidationsQuery,
} from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'
import hasFeature from 'modules/core/lib/hasFeature'

export type ResultValidation = NonNullable<
  GetResultValidationsQuery['payroll']
>['resultValidations'][number]
export type ResultValidationFormula = NonNullable<
  NonNullable<GetResultValidationsQuery['payroll']>['resultValidations'][number]
>['validation']

export const useResultValidations = (
  policyPeriodId: number,
  employeeIds?: number[],
  validationFormulaIds?: number[]
) => {
  const hasPayrollResultsValidation = hasFeature('dev_payroll_results_validation')

  const { data, error, refetch, loading } = useQuery(GetResultValidationsDocument, {
    variables: {
      policyPeriodId,
      employeeIds,
      validationFormulaIds,
    },
    notifyOnNetworkStatusChange: true,
    skip: !hasPayrollResultsValidation,
  })

  return {
    refetch,
    fetching: loading,
    data: (data?.payroll.resultValidations as ResultValidation[]) ?? [],
    error,
  }
}
